import { Separator } from '@/components/ui/separator'
import { cdnUrl } from 'commons/cdn'
import {
  Component1Icon,
  DimensionsIcon,
  LayersIcon,
} from '@radix-ui/react-icons'
import { Description, H2 } from 'components/ui/Title'
import React from 'react'
import { TemplateInitDataInfoDisplay } from 'AdminPanel/Spine/editor/panel/info-panel/components/TemplateInitDataInfoDisplay'
import {
  openOnlinesByPainter,
  openTemplatesByPublisher,
} from 'commons/worksLinks'

const InfoPanel = ({ draft }) => {
  return (
    <div className="w-full space-y-4 rounded-md border p-4">
      <H2>{draft.name}</H2>
      <Description>ID: {draft.id}</Description>
      {draft.type === 'template' && (
        <Description>Short id: {draft.shortId}</Description>
      )}
      <Description>Intro: {draft.intro}</Description>
      {draft.type === 'template' ? (
        <TemplateInitDataInfoDisplay
          cover={draft.cover}
          videoCover={draft.videoCover}
          videoCoverPreview={draft.videoCoverPreview}
          preview={draft.preview}
          videoPreview={draft.videoPreview}
          videoPreviewPreview={draft.videoPreviewPreview}
        />
      ) : (
        <div>
          <p>Cover</p>
          <img
            alt="..."
            className="aspect-square rounded-md object-contain bg-black w-24 h-24"
            src={cdnUrl(draft.cover)}
          />
        </div>
      )}
      <div className="flex items-center gap-4">
        {draft.type === 'template' && (
          <div className="flex items-center">
            <DimensionsIcon className="w-4 h-4 mr-2" />
            {draft.ow} x {draft.oh}
          </div>
        )}
        <div className="flex items-center">
          <LayersIcon className="w-4 h-4 mr-2" />
          {draft.layerCount}
        </div>
        <div className="flex items-center">
          <Component1Icon className="w-4 h-4 mr-2" />
          {draft.componentCount}
        </div>
      </div>
      <div className="flex gap-2">
        {draft.painter || draft.author ? (
          <button
            type="button"
            className="font-medium underline underline-offset-4"
            title={draft.painter || draft.author}
            onClick={() =>
              openTemplatesByPublisher(draft.painter || draft.author)
            }
          >
            {draft.publisher || draft.painter || draft.author}
          </button>
        ) : null}
        {draft.author ? (
          <button
            type="button"
            className="font-medium underline underline-offset-4"
            title={draft.author}
            onClick={() => openOnlinesByPainter(draft.author)}
          >
            {draft.onlinePublisher || draft.author}
          </button>
        ) : null}
      </div>
      <Separator className="my-4" />
      {draft.type === 'template' && (
        <Description>level: {draft?.ext?.level}</Description>
      )}
      <Description>
        tags:{' '}
        {draft?.ext?.tags?.map((item) => (
          <span key={item}>{item}、</span>
        ))}
      </Description>
      {draft.type === 'template' && (
        <Description>
          labels:{' '}
          {draft?.ext?.labels?.map((item) => (
            <span key={item}>{item}、</span>
          ))}
        </Description>
      )}
      {draft.type === 'template' && (
        <Description>
          contentLangs:{' '}
          {draft?.ext?.contentLangs?.map((item) => (
            <span key={item}>{item}、</span>
          ))}
        </Description>
      )}
      {draft.type === 'template' && (
        <Description>
          productIds:{' '}
          {draft?.ext?.productIds?.length ? (
            draft.ext.productIds.map((item) => (
              <span key={item}>{item}、</span>
            ))
          ) : (
            <span className="text-muted-foreground">未设置（未上任何产品）</span>
          )}
        </Description>
      )}

      {draft.type === 'template' && (
        <Description>simpleLimit: {draft?.ext?.simpleLimit}</Description>
      )}
      {draft.type === 'dlc' && (
        <Description>sku: {draft?.ext?.sku}</Description>
      )}
    </div>
  )
}

export default InfoPanel
